import { createWebHashHistory, createRouter } from "vue-router";
import LoaderDeal from "@/components/LoaderDeal";
import Main from "@/components/Main";
import OffersExt from "@/components/OffersExt";
import FloatPopup from "@/components/FloatPopup";
import Store from "@/components/Store";

const NotFound = { template: '<h2>Oops, it looks like the page you\'re looking for doesn\'t exist.</h2>' }

const routes = [
  {
    path: "/",
    name: "Main",
    component: Main,
    children: [
      {
        path: '/store/:storeId',
        component: Store,
      }
    ]
  },
  {
    path: "/load",
    name: "Loader",
    component: LoaderDeal,
  },
  {
    path: "/offers",
    name: "Offers",
    component: OffersExt,
  },
  {
    path: "/floatpopup",
    name: "Float",
    component: FloatPopup,
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: NotFound,
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;